import type { ReactNode } from "react";

export function Section({
  title,
  blurb,
  children,
  tone = "default",
}: {
  title: string;
  blurb?: string;
  children: ReactNode;
  tone?: "default" | "danger";
}) {
  return (
    <section
      className={`rounded-large border p-4 ${
        tone === "danger"
          ? "border-danger/40 bg-danger/5"
          : "border-default-100/60 bg-default-50/20"
      }`}
    >
      <h2 className="text-base font-medium">{title}</h2>
      {blurb && <p className="mt-1 mb-3 max-w-3xl text-xs leading-relaxed text-default-400">{blurb}</p>}
      {children}
    </section>
  );
}

export function Stat({
  label,
  value,
  sub,
  tone = "default",
}: {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  tone?: "default" | "primary" | "danger" | "success" | "warning";
}) {
  const colour = {
    default: "text-default-200",
    primary: "text-primary",
    danger: "text-danger",
    success: "text-success",
    warning: "text-warning",
  }[tone];

  return (
    <div className="rounded-medium border border-default-100/60 bg-default-50/30 px-3 py-2">
      <div className="text-[10px] tracking-wide text-default-500 uppercase">{label}</div>
      <div className={`font-mono text-xl leading-tight ${colour}`}>{value}</div>
      {sub && <div className="mt-0.5 text-[11px] text-default-500">{sub}</div>}
    </div>
  );
}
